/** Raises a click event. */
export function raiseClick(target) {
    var event = new Event('MouseEvents');
    event.initEvent('click', true, true);
    target.dispatchEvent(event);
}
//# sourceMappingURL=raiseClick.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/utilities/lib/dom/raiseClick.js
// module id = 612
// module chunks = 0